<div class="row p-3 animated fadeIn">
  <h4 class="heading">Biography</h4>
  <span [innerHTML]="biography"></span>
</div>
